export default __webpack_public_path__ + "static/media/0x9c78ee466d6cb57a4d01fd887d2b5dfb2d46288f.e8d82c98.webp";